<template>
  <div class="stepsdemo-content" id="step-info-contratto">
    <Card v-if="!loading">
      <template v-slot:title>
        <div class="grid"> 
          <p class="m-0 col-12 text-center">Informazioni Contratto</p>
          <TutorialDialog :slides="slides" :window-size="windowSize" />
        </div>
      </template>

      <template v-slot:content>
        <div class="flex flex-wrap justify-content-center box-option">
          <label class="m-2 col-12 flex justify-content-center">
            <strong>Tipologia contratto</strong>
          </label>
          <div class="w-full grid justify-content-between">
            <Button v-for="pratica in pratiche" :key="pratica.id" :class="`card-primary btn-pratica btn-selection ${pratica.selected ? 'selected' : ''}`" :label="'Nuovo Contratto con '+pratica.name" @click="setNewContract(pratica)"></Button>
          </div>
        </div>

        <div class="flex flex-wrap justify-content-between align-items-center box-option p-2" v-if="visibleStepInfo">
          <!-- Selezione agente -->
          <div class="col-12 xl:col-6">
            <label class="m-2 col-12 flex justify-content-center">
              <strong>Agente</strong>
            </label>
            <div v-if="loaded_agenti">
              <Dropdown v-if="currentUser.role == 'admin'" v-model="selectedAgent" :options="agents" filter optionLabel="name" optionValue="id" placeholder="Seleziona un agente" class="w-full m-1 col-12 xl:col-6" @update:modelValue="onChangeAgent()"/>
              <TreeSelect v-else v-model="selectedKeyAgent" :options="agents" optionLabel="name" optionValue="id" placeholder="Seleziona un agente" class="w-full m-1" :expandedKeys="expandedKeys" @node-select="onChangeAgent($event)">
                <template #header>
                  <span class="field grid p-2">
                    <div class="col-10 pl-4">
                      <span class="p-input-icon-right" style="width: 100%">
                        <InputText type="text" class="w-full" v-model="search" id="search-input" placeholder="Cerca Agente per Nome o Email"/>
                        <i class="pi pi-search" />
                      </span>
                    </div>
                    <Button label="Azzera Filtro" class="w-2 p-button-sm text-white font-semibold" @click="resetFilter"/>
                  </span>
                </template>
              </TreeSelect>
            </div>
            <div v-else class="flex flex-wrap">
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
            </div>          <!-- View offerte -->
          </div>
          <div v-if="selectedAgent" class="col-12 xl:col-6">
            <label class="col-12 flex justify-content-center">
              <strong>Offerte disponibili</strong>
            </label>
            <div v-if="loaded_offerte">
              <div v-if="offerte.length > 0" class="scroll-container">
                <Chip v-for="offerta in offerte" :key="offerta.id" :label="offerta.name" class="m-1"/>
              </div>
              <div v-else>
                <InlineMessage severity="warn">L'agente selezionato non ha offerte associate</InlineMessage>
              </div>
            </div>
            <div v-else class="flex flex-wrap">
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="23%" style="margin: 1%;" height="2rem" borderRadius="16px"></Skeleton>
            </div>
          </div>
        </div>
        
        <div class="flex flex-wrap justify-content-center box-option" v-if="selectedAgent && offerte.length > 0 && visibleStepInfo">
          <!-- Selezione Cliente -->
          <label class="m-2 col-12 flex justify-content-center">
            <strong>Tipologia cliente</strong>
          </label>

          <div class="w-full grid justify-content-between">
            <Button v-for="tipo in typesClient" :key="tipo" :label="(tipo.name.replaceAll('/',' ')).toUpperCase()" :class="`card-primary btn-tipo-cliente btn-selection ${tipo.selected ? 'selected' : ''}`" @click="onChangeTypeClient(tipo.id)"/>
          </div>
          
          <div class="p-0 col-12" v-if="canViewSelectionClient">
            <div class="w-full flex flex-wrap justify-content-center" v-if="cliente.exist === null">
              <div class="p-5 col-12 xl:col-6">
                <label class="pb-2" for="codfis">Codice Fiscale <span class="p-error">(obbligatorio)</span></label><br>
                <InputMask class="text_toupper" :mask="mask.cf" :key="mask.cf" @complete="inputCF_PIVA()" v-model="cf" :class="['inputfield w-full',{'p-invalid': validationErrors.codfis && submitted}]"/>                
                <div class="col-12 flex justify-content-between mt-3" v-if="![2,3,4].includes(selectedTypeClient)">
                  <label><strong>La partita Iva coincide con il codice fiscale</strong></label>
                  <Checkbox v-model="sameCfPiva" :binary="true" @change="setSameCfPiva"/>
                </div>
              </div> 
              <div class="p-5 col-12 xl:col-6" v-if="![2,3].includes(selectedTypeClient)">
                <label class="pb-2" for="piva">Partita Iva <span class="p-error">(obbligatorio)</span></label><br>
                <InputMask class="text_toupper" :mask="mask.piva" @complete="inputCF_PIVA()" v-model="piva" :class="['inputfield w-full',{'p-invalid': validationErrors.pivas && submitted}]"/>
              </div>
            </div>
            <div class="w-full flex flex-wrap" v-else>
              <div v-if="cliente.can_view" class="w-full">
                <label class="m-2 col-12 flex justify-content-center">
                  <strong>Cliente</strong>
                </label>

                <div v-if="cliente.exist" class="w-full">
                  <div class="flex flex-column justify-content-center box-selected p-2">
                    <Button icon="pi pi-trash" class="btn-remove-selected p-button-rounded p-button-text p-button-danger p-button-sm" aria-label="Rimuovi selezionato" v-tooltip="'Rimuovi selezionato'" @click="initClient(true)"/>
                    <h4 class="selected-name">
                      <a v-if="clientDetailUrl" class="btn-detail-name" :href="clientDetailUrl" target="_blank" rel="noopener noreferrer" v-tooltip="'Apri dettaglio cliente'">{{selectedTypeClient == 2 ? `${cliente.cognome} ${cliente.nome}` : cliente.ragsoc}}</a>
                      <span v-else>{{selectedTypeClient == 2 ? `${cliente.cognome} ${cliente.nome}` : cliente.ragsoc}}</span>
                    </h4>
                    <p class="m-0 col-12 flex flex-column align-items-center">
                      <span class="w-full flex justify-content-center align-items-center">Codice Fiscale: <strong class="m-1"> {{ cliente.codfis }}</strong></span>
                      <span class="w-full flex justify-content-center align-items-center" v-if="![2,3].includes(selectedTypeClient)">Partita Iva: <strong class="m-1"> {{ cliente.piva }}</strong></span>
                    </p>
                  </div>
                </div>
                <div v-else class="flex flex-wrap">
                  <div class="flex justify-content-center col-12">
                    <Button class="p-button-rounded card-primary col-3 btn-reset" @click="initClient(true)" icon="pi pi-arrow-up" label="Ritorna alla ricerca"/>
                  </div>
                  <div class="p-field col-12 xl:col-6">
                    <label for="codfis">Codice Fiscale <span class="p-error">(obbligatorio)</span></label><br>
                    <InputMask disabled class="text_toupper" :mask="mask.cf" id="codfis" v-model="cliente.codfis" :class="['inputfield w-full',{'p-invalid': validationErrors.codfis && submitted}]"/>
                    
                  </div> 
                  <div class="p-field col-12 xl:col-6" v-if="selectedTypeClient != 2">
                    <label for="piva">Partita Iva <span class="p-error">(obbligatorio)</span></label><br>
                    <InputMask disabled :mask="mask.piva" id="piva" v-model="cliente.piva" :class="['inputfield w-full',{'p-invalid': validationErrors.piva && submitted}]"/>
                    
                  </div>
                  <!--Nome Cliente-->
                  <div v-if="selectedTypeClient == 2" class="p-field col-12 xl:col-6">
                    <label for="nome">Nome <span class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="nome" v-model="cliente.nome" :class="['inputfield w-full',{'p-invalid': validationErrors.nome && submitted}]" @input="(val) => (cliente.nome = cliente.nome.toUpperCase())"/>
                  </div>
                  <!--Cognome Cliente-->
                  <div v-if="selectedTypeClient == 2" class="p-field col-12 xl:col-6">
                    <label for="cognome">Cognome <span class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="cognome" v-model="cliente.cognome" class="inputfield w-full" @input="(val) => (cliente.cognome = cliente.cognome.toUpperCase())"/>
                  </div>
                  <!--Ragione sociale Cliente-->
                  <div v-if="selectedTypeClient != 2" class="p-field col-12">
                    <label for="ragsoc">Ragione Sociale <span class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="ragsoc" v-model="cliente.ragsoc" :class="['inputfield w-full',{'p-invalid': validationErrors.ragsoc && submitted}]" @input="(val) => (cliente.ragsoc = cliente.ragsoc.toUpperCase())"/>
                  </div>
                  <!--Cellulare Cliente-->
                  <div class="p-field col-12 xl:col-6">
                    <label for="mobile">Cellulare <span class="p-error">(obbligatorio)</span></label><br>                   
                    <InputMask @change="onSelectedMobile($event)" id="mobile" mask="999-999999?9" v-model="cliente.cellulare" :class="['inputfield w-full',{'p-invalid': validationErrors.cellulare && submitted}]" />
                    <small v-show="validationErrors.cellulare_incorrect" class="p-error">Ricontrolla il numero di cellulare inserito.</small>
                    <small v-show="validationErrors.noTelCell" class="p-error">Inserisci un numero di cellulare</small>
                  </div> 
                  <Dialog id="modalShow" v-model:visible="showModal" :style="{width: '450px'}" :modal="true">
                    <div class="confirmation-content">          
                      <p>Hai inserito il numero telefonico: {{ cliente.cellulare }}</p> 
                      <p>É corretto?</p>   
                    </div>
                    <template #footer>
                      <Button @click="isCorrect(true)" label="Si" type="button" icon="pi pi-check" iconPos="left" class="p-button-success btn-multisito m-2" />
                      <Button @click="isCorrect()" label="No" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito m-2" />
                    </template>
                  </Dialog>
                  <!--Telefono Cliente-->
                  <div class="p-field col-12 xl:col-6">
                    <label for="telefono">Telefono</label><br>                   
                    <InputMask @change="onSelectedTelefono($event)" id="telefono" mask="999-999999?9" v-model="cliente.telefono" :class="['inputfield w-full',{'p-invalid': validationErrors.telefono && submitted}]"/>
                  </div> 
                  <!--Email Cliente-->
                  <div class="p-field col-12 xl:col-6">
                    <label for="email">Email <span v-if="selectedTypeClient == 2" class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="email" v-model="cliente.email" :class="['inputfield w-full',{'p-invalid': validationErrors.email || validationErrors.isEmail && submitted}]" @input="(val) => (cliente.email = cliente.email.toLowerCase())"/>
                    <div v-show="validationErrors.isEmail && submitted" class="p-error">Formato errato.</div>
                  </div>
                  <!--Pec Cliente-->
                  <div v-if="selectedTypeClient != 2" class="p-field col-12 xl:col-6">
                    <label for="pec">Pec</label><br>
                    <InputText id="pec" v-model="cliente.pec" :class="['inputfield w-full',{'p-invalid': validationErrors.pec || validationErrors.ispec && submitted}]" @input="(val) => (cliente.pec = cliente.pec.toLowerCase())"/>
                  </div>
                  <!--Codice Ateco Cliente-->
                  <div v-if="![2,3].includes(selectedTypeClient)" class="p-field col-12 xl:col-6">
                    <label>Codice Ateco <span class="p-error">(obbligatorio)</span></label><br>
                    <Dropdown @change="onSelectedAteco()" v-model="cliente.codiceAteco" :options="codiciAteco" optionLabel="label" optionGroupLabel="label" optionGroupChildren="items" optionValue="value" placeholder="Seleziona un codice ateco" :filter="true" class="inputfield w-full">
                      <template #optiongroup="slotProps">
                        <div class="flex align-items-center">
                          <div style="white-space-collapse:break-spaces;">{{ slotProps.option.label }}</div>
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                  <!--Codice Destinatario Cliente-->
                  <div class="p-field col-12 xl:col-6">
                    <label>Codice Sdi <span class="p-error">(obbligatorio)</span></label><br>
                    <Dropdown class="w-full" v-model="cliente.codiceDestinatario" :options="sdi" placeholder="Seleziona" :filter="true" :showClear="true" optionLabel="sdi" optionValue="sdi" :disabled="selectedTypeClient == 2" @change="onSelectedSdi" @update:modelValue="onSelectedSdi" :editable="selectedTypeClient == 5"/>
                    <small v-show="validationErrors.sdi_invalid && submitted" class="p-error">Formato errato.</small>
                  </div> 
                  <!--Codice INdirizzo sede legale-->
                  <div class="p-field col-12 mt-2">
                    <h5>Indirizzo sede legale</h5>
                    <hr>
                  </div>
                  <div class="p-field col-12 xl:col-6">
                    <label>Toponimo <span class="p-error">(obbligatorio)</span></label><br>
                    <Dropdown @change="onSelectedToponimo($event, 'cliente')" v-model="cliente.toponimo" :options="toponimi" optionLabel="name" optionValue="name" :filter="true" placeholder="Seleziona toponimo" class="inputfield w-full"/>
                  </div>
                  <div class="p-field col-12 xl:col-6">
                    <label for="indirizzo">Indirizzo <span class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="indirizzo" v-model="cliente.indirizzo" class="inputfield w-full" @input="(val) => (cliente.indirizzo = cliente.indirizzo.toUpperCase())"/>
                  </div>
                  <div class="p-field col-12 xl:col-6">
                    <label for="civico">Civico <span class="p-error">(obbligatorio)</span></label><br>
                    <InputText @change="onSelected($event)" id="civico" v-model="cliente.civico" class="inputfield w-full" @input="(val) => (cliente.civico = cliente.civico.toUpperCase())"/>
                  </div>
                  <div class="p-field col-12 xl:col-6">
                    <label for="cap">Cap <span class="p-error">(obbligatorio)</span></label><br>
                    <InputMask mask="99999" @change="onSelected($event)" id="cap" v-model="cliente.cap" class="inputfield w-full" />
                  </div> 
                  <div class="p-field col-12 xl:col-6">
                    <label>Provincia <span class="p-error">(obbligatorio)</span></label><br>
                    <Dropdown @change="onSelectedDistrict($event, 'cliente')" v-model="cliente.provincia" :options="province" optionLabel="name" :filter="true" optionValue="code" placeholder="Seleziona provincia" class="inputfield w-full" />
                  </div>
                <div class="p-field col-12 xl:col-6">
                  <label>Comune <span class="p-error">(obbligatorio)</span></label><br>
                  <Dropdown @change="onSelectedCity($event, 'cliente')" v-model="cliente.cod_comune" :options="cities_cliente" :filter="true" optionLabel="name" optionValue="id" placeholder="Seleziona comune" class="inputfield w-full" />
                </div>
                </div>
                <div v-if="selectedTypeClient == 2 && contatti.length" class="w-full flex flex-wrap">
                  <label class="m-2 col-12 flex justify-content-center">
                    <strong>Contatto</strong>
                  </label>

                  <div class="p-field col-12 xl:col-6 flex justify-content-between mt-3">
                    <label><strong>L'indirizzo di spedizione coincide con l'indirizzo della sede legale</strong></label>
                    <Checkbox v-model="sameAddress" :binary="true" :disabled="Boolean(repairSourceContactId)" @change="setSameAddress"/>
                  </div>
  
                  <div class="w-full grid justify-content-around">
                    <Button v-for="contatto in contatti" :key="contatto.same_to_client ? 'same_to_client' : contatto.id" :class="`card-primary flex flex-column align-items-start btn-contatto btn-selection ${(repairSourceContactId ? contatto.id == repairSourceContactId : contatto.selected) ? 'selected' : ''} ${(contatto.invalid_fields?.length > 0) ? 'needs-completion' : ''} ${(canGoToStep2.duplicateContact === contatto) ? 'duplicate-contact' : ''}`" v-tooltip="{value: canGoToStep2.duplicateContact === contatto ? 'Contatto da selezionare' : 'Seleziona per completare il contatto', disabled: canGoToStep2.duplicateContact !== contatto && !(contatto.invalid_fields?.length > 0)}" @click="onSelectedContact(contatto)">
                      <span v-if="canGoToStep2.duplicateContact === contatto" class="duplicate-contact-badge" title="Seleziona questo contatto"><span aria-hidden="true">&#128073;</span><span class="p-sr-only">Seleziona questo contatto</span></span>
                      <span v-if="contatto.same_to_client" class="same-client-badge">Sede legale cliente</span>
                      <p class="m-0">
                        <span class="contact-label">Indirizzo:</span>
                        {{ `${contatto.toponimo ?? ''} ${contatto.indirizzo ?? ''} ${contatto.civico ?? ''}, ${contatto.cap ?? ''} - ${contatto.nome_comune ?? ''} ${contatto.provincia ?? ''}` }}
                      </p>
                      <div v-if="contatto.invalid_fields?.includes('toponimo')" class="contact-data invalid-contact-data">
                        <span class="contact-label">Toponimo:</span> {{ contatto.toponimo || 'Mancante' }}<span v-if="contatto.toponimo"> (Dato errato)</span>
                      </div>
                      <div v-if="contatto.invalid_fields?.includes('indirizzo')" class="contact-data invalid-contact-data">
                        <span class="contact-label">Indirizzo:</span> Mancante
                      </div>
                      <div v-if="contatto.invalid_fields?.includes('civico')" class="contact-data invalid-contact-data">
                        <span class="contact-label">Civico:</span> Mancante
                      </div>
                      <div v-if="contatto.invalid_fields?.includes('cap')" class="contact-data invalid-contact-data">
                        <span class="contact-label">CAP:</span> {{ contatto.cap || 'Mancante' }}<span v-if="contatto.cap"> (Dato errato)</span>
                      </div>
                      <div class="contact-data" :class="{'invalid-contact-data': contatto.invalid_fields?.includes('cell')}">
                        <span class="contact-label">Cellulare:</span> {{ contatto.cell !== '' && contatto.cell != null ? contatto.cell : 'Mancante' }}<span v-if="contatto.cell !== '' && contatto.cell != null && contatto.invalid_fields?.includes('cell')"> (Dato errato)</span>
                      </div>
                      <div class="contact-data" :class="{'invalid-contact-data': contatto.invalid_fields?.includes('email')}">
                        <span class="contact-label">Email:</span> {{ contatto.email !== '' && contatto.email != null ? contatto.email : 'Mancante' }}<span v-if="contatto.email !== '' && contatto.email != null && contatto.invalid_fields?.includes('email')"> (Dato errato)</span>
                      </div>
                    </Button>
                  </div>
                  <div class="col-12 flex justify-content-center mt-3">
                    <Button label="Aggiungi nuovo contatto" icon="pi pi-plus" class="p-button-sm card-primary btn-reset" @click="addNewContact"/>
                  </div>
                </div>
                <div v-if="selectedTypeClient == 2 && !contatti.length" class="p-field col-12 xl:col-6 flex justify-content-between mt-3">
                  <label><strong>L'indirizzo di spedizione coincide con l'indirizzo della sede legale</strong></label>
                  <Checkbox v-model="sameAddress" :binary="true" @change="setSameAddress"/>
                </div>
                <div v-if="selectedTypeClient == 2 && !sameAddress && !selectedContact" ref="repairFormRef" class="grid mt-3 p-2" :class="{'contact-repair-form': repairSourceContactId}">
                  <div class="p-field col-12">
                    <h5>Indirizzo di spedizione</h5>
                    <small v-if="repairSourceContactId">Completa i dati mancanti o non validi per aggiornare il contatto.</small>
                    <hr>
                  </div> 

                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('toponimo')}">
                    <label>Toponimo <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('toponimo')" class="completion-note">da completare per proseguire</span></label><br>
                    <Dropdown @change="onSelectedToponimo($event, 'contatto')" v-model="contatto.toponimo" :disabled="isRepairFieldLocked('toponimo')" :options="toponimi" optionLabel="name" optionValue="name" :filter="true" placeholder="Seleziona toponimo" class="inputfield w-full"/>
                  </div> 

                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('indirizzo')}">
                    <label for="indirizzo">Indirizzo <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('indirizzo')" class="completion-note">da completare per proseguire</span></label><br>
                    <InputText @change="onSelected($event)" id="indirizzo" v-model="contatto.indirizzo" :disabled="isRepairFieldLocked('indirizzo')" :class="['inputfield w-full',{'p-invalid': validationErrors.indirizzo && submitted}]" @input="(val) => (contatto.indirizzo = contatto.indirizzo.toUpperCase())"/>
                    <small v-show="validationErrors.indirizzo && submitted" class="p-error">Campo richiesto.</small>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('civico')}">
                    <label for="civico">Civico <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('civico')" class="completion-note">da completare per proseguire</span></label><br>
                    <InputText @change="onSelected($event)" id="civico" v-model="contatto.civico" :disabled="isRepairFieldLocked('civico')" :class="['inputfield w-full',{'p-invalid': validationErrors.civico && submitted}]" @input="(val) => (contatto.civico = contatto.civico.toUpperCase())"/>
                    <small v-show="validationErrors.civico && submitted" class="p-error">Campo richiesto.</small>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('provincia')}">
                    <label>Provincia <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('provincia')" class="completion-note">da completare per proseguire</span></label><br>
                    <Dropdown @change="onSelectedDistrict($event, 'contatto')" v-model="contatto.provincia" :disabled="isRepairFieldLocked('provincia')" :options="province" optionLabel="name" :filter="true" optionValue="code" placeholder="Seleziona provincia" :class="['inputfield w-full',{'p-invalid': validationErrors.provincia && submitted}]" />
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('comune')}">
                    <label>Comune <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('comune')" class="completion-note">da completare per proseguire</span></label><br>
                    <Dropdown @change="onSelectedCity($event, 'contatto')" v-model="contatto.comune" :disabled="isRepairFieldLocked('comune') || !contatto.provincia" :options="cities_contatto" :filter="true" optionLabel="name" optionValue="id" placeholder="Seleziona comune" :class="['inputfield w-full',{'p-invalid': validationErrors.comune_contatto && submitted}]" />
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('cap')}">
                    <label for="cap">Cap <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('cap')" class="completion-note">da completare per proseguire</span></label><br>
                    <div v-tooltip.top="{value: 'È necessario selezionare prima il comune', disabled: Boolean(contatto.cod_comune ?? contatto.comune)}" class="w-full">
                      <div v-if="contactCapSettings.isWildcard" class="p-inputgroup">
                        <span class="p-inputgroup-addon contact-cap-prefix">{{ contactCapSettings.cap.slice(0, 3) }}</span>
                        <input type="text" inputmode="numeric" maxlength="2" placeholder="Ultime 2 cifre" aria-label="Ultime due cifre del CAP" @input="onContactCapSuffixInput" @change="onSelected($event)" id="cap" :value="contactCapSuffix" :disabled="isRepairFieldLocked('cap')" :class="['p-inputtext p-component inputfield w-full',{'p-invalid': validationErrors.cap && submitted}]">
                      </div>
                      <InputMask v-else :mask="contactCapSettings.mask" @change="onSelected($event)" id="cap" v-model="contatto.cap" :disabled="isRepairFieldLocked('cap') || !(contatto.cod_comune ?? contatto.comune) || (!repairSourceContactId && contactCapSettings.isFixed)" :class="['inputfield w-full',{'p-invalid': validationErrors.cap && submitted}]" />
                    </div>
                    <small v-show="validationErrors.cap && submitted" class="p-error">Campo richiesto.</small>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('email')}">
                    <label for="email_contatto">Email <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('email')" class="completion-note">da completare per proseguire</span></label><br>
                    <InputText id="email_contatto" v-model="contatto.email" :disabled="isRepairFieldLocked('email')" :class="['inputfield w-full',{'p-invalid': validationErrors.email_contatto && submitted}]" @input="(val) => (contatto.email = contatto.email.toLowerCase())" @change="onSelected($event)"/>
                  </div>
                  <div class="p-field col-12 md:col-6 xl:col-4" :class="{'contact-field-to-complete': needsContactCompletion('cellulare')}">
                    <label for="cellulare_contatto">Cellulare <span class="p-error">(obbligatorio)</span><span v-if="needsContactCompletion('cellulare')" class="completion-note">da completare per proseguire</span></label><br>
                    <InputText v-if="repairSourceContactId && !isRepairFieldLocked('cellulare')" id="cellulare_contatto" v-model="contatto.cellulare" class="inputfield w-full" />
                    <InputMask v-else id="cellulare_contatto" mask="999-999999?9" v-model="contatto.cellulare" :disabled="isRepairFieldLocked('cellulare')" :class="['inputfield w-full',{'p-invalid': validationErrors.cellulare_contatto && submitted}]" @change="onSelected($event)"/>
                  </div>    
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer v-if="visibleStepInfo">
        <div class="grid justify-content-end align-items-center">  
          <div class="flex flex-column gap-2 mt-2">
            <InlineMessage v-if="canGoToStep2.disabled" severity="warn" class="w-full justify-content-start">
              {{ canGoToStep2.message }}
            </InlineMessage>

            <Button v-if="!canGoToStep2.disabled" label="Avanti" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" class="p-btn-footer card-primary btn-reset"/>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import TutorialDialog from './TutorialDialog.vue'
import {ref, getCurrentInstance, onMounted, onUpdated, onActivated, computed, watch, nextTick } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useToast } from 'primevue/usetoast';
import { useStore } from 'vuex'
import Dialog from 'primevue/dialog';
import moment from 'moment'
import { useRoute, useRouter } from 'vue-router';
import Opzioni from '@/config/opzioni'
import services from '@/config/services'
import { findDuplicateContact } from './contactComparison'
import { getContactCapSettings, isContactCapValid, withContactAddressValidation } from './contactAddressValidation'

export default {
  components: { TutorialDialog },
  props: {
    formData: Object
  },
  emits: [
    'activeLoader', 
    'activeLoaderCaricamento', 
    'prev-page', 
    'next-page', 
    'complete'
  ],
  setup (props, {emit}) {
    const loading = ref(true)
    const store = useStore()
    const currentUser = ref()
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const opzioni = new Opzioni()

    const route = useRoute()
    const toast = useToast();
    const stepIndex = 0
    // const isIvaAgevolata = ref(false)
    const sameAddress = ref(true)
    const sameCfPiva = ref(true)
    const typesClient = opzioni.tipologieCliente
    const toponimi = opzioni.toponimi
    const province = opzioni.province
    const selectedTypeClient = ref(0)
    const selectedContact = ref(null)
    const repairSourceContactId = ref(null)
    const repairLockedFields = ref({})
    const repairInitialValues = ref({})
    const repairFormRef = ref(null)
    const offerte = ref([])
    const cliente = ref({})
    const clientDetailUrl = computed(() => currentUser.value?.role === 'admin' && cliente.value.id
      ? `${services.admin.url.replace(/\/$/, '')}/ask/clienti/${encodeURIComponent(cliente.value.id)}/dettagli`
      : null)
    const contatto = ref({})
    const contactCapSettings = computed(() => getContactCapSettings(contatto.value.cod_comune ?? contatto.value.comune, opzioni.comuni))
    const contactCapSuffix = computed({
      get: () => {
        if (!contactCapSettings.value.isWildcard) return ''
        const prefix = contactCapSettings.value.cap.slice(0, 3)
        const cap = String(contatto.value.cap ?? '').replace(/\D/g, '')
        return cap.startsWith(prefix) ? cap.slice(3, 5) : ''
      },
      set: value => {
        const prefix = contactCapSettings.value.cap.slice(0, 3)
        const suffix = String(value ?? '').replace(/\D/g, '').slice(0, 2)
        contatto.value.cap = `${prefix}${suffix}`
      }
    })
    const onContactCapSuffixInput = event => {
      const suffix = String(event.target.value ?? '').replace(/\D/g, '').slice(0, 2)
      event.target.value = suffix
      contactCapSuffix.value = suffix
    }
    const validationErrors = ref({})
    const submitted = ref(false)
    const initializedKey = ref(null)
    const initializing = ref(false)
    let clientSearchVersion = 0

    const activeTabIndex = ref(0)
    const clients = ref([])
    const clienti = ref([])
    const cities_cliente = ref([])
    const cities_contatto = ref([])
    const contatti = ref([])
    const newContatto = ref(false)
    const sdi = ref([])
    const visibleStepInfo = ref()
    const pratica_contratto = ref()
    const nome_pratica_contratto = ref()
    const agents = ref([])
    const originalAgents = ref([])
    const selectedAgent = ref()
    const selectedKeyAgent = ref()
    const search = ref(null);
    const expandedKeys = ref({});

    const windowSize = ref(window.innerWidth)
    const canViewSelectionClient = ref()
    const dati_matrice_da_modificare = ref({
      cliente: {
        codfis: null
      }
    })

    const loaded_offerte = ref(false)
    const loaded_agenti = ref(false)
    const loaded_cliente = ref(true)
    const cities = ref([])
    const selectedTipo = ref(null)
    const selectedTipoName = ref('')
    const tipoCliente = ref([])
    const cod_fiscale = ref('')
    const partita_iva = ref('')
    const nome_domestico = ref('')
    const cognome_domestico = ref('') 
    const toponimo_domestico = ref('') 
    const indirizzo_domestico = ref('') 
    const civico_domestico = ref('') 
    const cap_domestico = ref('') 
    const comune_domestico = ref('') 
    const provincia_domestico = ref('') 

    const rag_sociale = ref('')
    const cod_fiscale_azienda = ref('') 
    const phone = ref('') 
    const cellulare_domestico = ref(null) 
    const email_domestico = ref('')
    const pec = ref('')
    const score = ref('')
    const selectedToponimo = ref(null)
    const address = ref()
    const civico = ref('')
    const cap = ref(null)
    const selectedDistrict = ref(null)
    const selectedCity = ref(null)
    const selectedCityName = ref('')
    const codice_destinatario = ref('')
    const codice_ateco = ref('')
    const note = ref('')

    const cf = ref()
    const piva = ref()

    const showModal = ref(false)
    const visibleOfferte = ref(false)
    const slides = ref([])
    const pratiche = ref([
      {id: 1, name: 'Switch', value: null, selected: false},
      {id: 17, name: 'Voltura', value: 'v', selected: false},
      {id: 34, name: 'Subentro', value: 's', selected: false},
      {id: 20, name: 'Attivazione su preposato', value:'ap', selected: false}
    ])
    const codiciAteco = ref([])
    
    const filterAgents = (nodesToFilter, term) => {
      if (!term || term.trim() === '') {
        return JSON.parse(JSON.stringify(originalAgents.value)); // Resetta ai dati originali
      }
      
      const filtered = [];
      const lowerCaseTerm = term.toLowerCase();
      
      nodesToFilter.forEach(node => {
        let matches = false;
        const nodeCopy = { ...node }; // Lavora su una copia del nodo
        
        // Controlla se il nodo stesso corrisponde (label, name o email)
        if (nodeCopy.label.toLowerCase().includes(lowerCaseTerm) ||
          nodeCopy.name.toLowerCase().includes(lowerCaseTerm) || // Aggiunto 'name' per la ricerca
          (nodeCopy.email && nodeCopy.email.toLowerCase().includes(lowerCaseTerm))) { // Aggiunto 'email'
          matches = true;
        }
        
        // Ricerca ricorsiva nei figli
        if (nodeCopy.children && nodeCopy.children.length > 0) {
          nodeCopy.children = filterAgents(nodeCopy.children, term);
          if (nodeCopy.children.length > 0) { // Se un figlio corrisponde, anche il genitore deve essere incluso
            matches = true;
          }
        }
        
        if (matches) {
          filtered.push(nodeCopy);
        }
      });
      return filtered;
    };
    
    const expandFiltered = () => {
      expandedKeys.value = {}; // Resetta le chiavi espanse
      for (let node of agents.value) { // Itera sui nodi attualmente filtrati
        expandNode(node, search.value);
      }
      expandedKeys.value = { ...expandedKeys.value }; // Assicura la reattività      
    };
    
    const expandNode = (node, filterTerm) => {
      const lowerCaseFilter = filterTerm ? filterTerm.toLowerCase() : '';
      
      const nodeMatches = (node.label && node.label.toLowerCase().includes(lowerCaseFilter)) ||
      (node.name && node.name.toLowerCase().includes(lowerCaseFilter)) ||
      (node.email && node.email.toLowerCase().includes(lowerCaseFilter));
      
      let childrenMatch = false;
      if (node.children && node.children.length > 0) {
        childrenMatch = node.children.some(child => {
          return expandNode(child, filterTerm)
        });
      }
      
      if (nodeMatches || childrenMatch) {
        expandedKeys.value[String(node.key)] = true;
        return true
      }
      return false
    };
    const resetFilter = () => {
      search.value = null; // Pulisce il campo di ricerca
      agents.value = JSON.parse(JSON.stringify(originalAgents.value)); // Ripristina i dati originali
      expandedKeys.value = {}; // Chiude tutti i nodi
    };  
    watch(search, newValue => {
      // Debounce per evitare chiamate troppo frequenti mentre l'utente digita
      setTimeout(async () => {
        if (newValue === search.value) { // Verifica che il valore non sia cambiato nel frattempo
          agents.value = filterAgents(originalAgents.value, search.value);          
          if (search.value && search.value.trim().length > 0) {
            expandFiltered(); // Espande i nodi pertinenti al filtro
          } else {
            expandedKeys.value = {}; // Resetta l'espansione se la ricerca è vuota
          }
        }
      }, 300);
    });

    const initClient = (force = false) => {
      if (force) {
        clientSearchVersion++
        if (!loaded_cliente.value) emit("activeLoader", false)
        loaded_cliente.value = true
      }
      selectedContact.value = null
      cliente.value = {
        can_view: false,
        exist: null,

        cod_rapp: 0,
        codfis_rapp: '',
        name_rapp: '',
        id: 0,
        prev_id: 0,
        ragsoc: null,
        piva: null,
        nome: '',
        cognome: '',
        codfis: '',
        
        toponimo: '',
        indirizzo: '',
        civico: '',
        cap: '',
        provincia: null,
        cod_comune: null,
        nome_comune: '',
        
        codiceDestinatario: null,
        codiceAteco: null,
        missing_items: []
      }
      contatto.value = {
        id: 0,
        prev_id: 0,

        toponimo: "",
        indirizzo: "",
        civico: "",
        cap: "",
        provincia: null,
        cod_comune: null,
        nome_comune: "",

        email: "",
        pec: null,
        tel: null,
        cell: "",
        selected: false,
      }
      sameCfPiva.value = true
      sameAddress.value = true
      newContatto.value = false
      resetContactRepair()
      contatti.value = []
      validationErrors.value = {}
      if (force) {
        cf.value = null
        piva.value = null
      }
    }

    const getNormalizedContatto = (contact = {}) => {
      const normalized = {...contact}
      normalized.cellulare = normalized.cellulare || normalized.cell || ''
      normalized.cell = normalized.cell || normalized.cellulare || ''
      normalized.nome_comune = normalized.nome_comune || normalized.name || ''
      normalized.comune = normalized.comune || normalized.cod_comune || null
      normalized.same_to_client = Boolean(normalized.same_to_client)

      return normalized
    }
    const resetContactRepair = () => {
      repairSourceContactId.value = null
      repairLockedFields.value = {}
      repairInitialValues.value = {}
    }
    const hasValue = value => value !== null && value !== undefined && String(value).trim() !== ''
    const needsContactCompletion = field => {
      if (!repairSourceContactId.value || repairLockedFields.value[field]) return false
      if (field === 'cap') return !isContactCapValid(contatto.value.cap, contatto.value.cod_comune ?? contatto.value.comune, opzioni.comuni)
      const value = contatto.value[field]
      return (hasValue(value) && value === repairInitialValues.value[field]) || !hasValue(['cellulare', 'cap'].includes(field) ? String(value || '').replace(/[_\s-]/g, '') : value)
    }
    const optionName = value => String(value?.name ?? value ?? '').trim().toLocaleUpperCase()
    const isValidMobile = value => {
      const mobile = String(value || '').replace(/\D/g, '')
      return /^3\d{8,9}$/.test(mobile)
        && !/^(\d)\1+$/.test(mobile)
        && !/^3(\d)\1+$/.test(mobile)
        && !['3123456789', '3234567890', '3987654321', '3098765432'].includes(mobile)
    }
    const isValidEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())
    const getCompleteContactFields = contact => {
      if (Array.isArray(contact.complete_fields)) return [...contact.complete_fields]
      const normalized = getNormalizedContatto(contact)
      const invalidFields = new Set(contact.invalid_fields || [])
      const contactCities = normalized.provincia ? opzioni.getCities(normalized.provincia) : []
      const checks = {
        toponimo: toponimi.some(item => optionName(item.name) === optionName(normalized.toponimo)),
        indirizzo: hasValue(normalized.indirizzo),
        civico: hasValue(normalized.civico),
        cap: !invalidFields.has('cap') && isContactCapValid(normalized.cap, normalized.comune, opzioni.comuni),
        provincia: province.some(item => optionName(item.code) === optionName(normalized.provincia)),
        comune: contactCities.some(item => item.id == normalized.comune),
        email: !invalidFields.has('email') && isValidEmail(normalized.email),
        cellulare: !invalidFields.has('cell') && isValidMobile(normalized.cellulare)
      }
      return Object.keys(checks).filter(field => checks[field])
    }
    const withCompleteContactFields = contact => {
      const normalized = withContactAddressValidation(getNormalizedContatto(contact), toponimi, opzioni.comuni)
      normalized.complete_fields = getCompleteContactFields(normalized)
      return normalized
    }
    const isRepairFieldLocked = field => {
      if (!repairSourceContactId.value) return false
      return contatto.value.complete_fields?.includes(field) === true
    }
    const completeContact = (source) => {
      const repaired = withCompleteContactFields(source)
      delete repaired.invalid_fields
      delete repaired.selectable
      repaired.id = source.id
      repaired.updated = true
      repaired.prev_id = source.id
      repaired.selected = false
      repaired.same_to_client = false
      const provinceOption = province.find(item => optionName(item.name) === optionName(repaired.provincia))
        || province.find(item => optionName(item.code) === optionName(repaired.provincia))
      const provinceValid = Boolean(provinceOption)
      repaired.provincia = provinceOption?.code ?? repaired.provincia
      cities_contatto.value = provinceValid ? opzioni.getCities(repaired.provincia) : []
      const cityOption = cities_contatto.value.find(item => optionName(item.name) === optionName(repaired.nome_comune || repaired.comune))
        || cities_contatto.value.find(item => item.id == repaired.comune)
      const cityValid = Boolean(cityOption)
      if (cityValid) {
        repaired.comune = cityOption.id
        repaired.cod_comune = cityOption.id
        repaired.nome_comune = cityOption.name
        if (!isContactCapValid(repaired.cap, cityOption.id, opzioni.comuni)) {
          repaired.cap = getContactCapSettings(cityOption.id, opzioni.comuni).prefill
        }
      }
      const toponimoOption = toponimi.find(item => optionName(item.name) === optionName(repaired.toponimo))
      repaired.toponimo = toponimoOption?.name ?? repaired.toponimo
      repairLockedFields.value = repaired.complete_fields.reduce((fields, field) => {
        fields[field] = true
        return fields
      }, {})
      repairInitialValues.value = {...repaired}
      repairSourceContactId.value = source.id
      removeSameAddressContact()
      contatti.value.forEach(contact => { contact.selected = false })
      selectedContact.value = null
      sameAddress.value = false
      newContatto.value = true
      contatto.value = repaired
      submitted.value = false
      validationErrors.value = {}
      nextTick(() => repairFormRef.value?.scrollIntoView({behavior: 'smooth', block: 'start'}))
    }
    const getClienteContactPhone = () => {
      return cliente.value.cellulare || cliente.value.cell || ''
    }
    const getContattoSyncKey = (contact = {}) => {
      const normalized = getNormalizedContatto(contact)

      return [
        normalized.id || 0,
        normalized.same_to_client ? 1 : 0,
        normalized.toponimo || '',
        normalized.indirizzo || '',
        normalized.civico || '',
        normalized.cap || '',
        normalized.provincia || '',
        normalized.cod_comune || normalized.comune || '',
        normalized.nome_comune || '',
        normalized.email || '',
        normalized.cell || ''
      ].join('|')
    }
    const hasFormDataPratica = () => {
      return Object.prototype.hasOwnProperty.call(props.formData || {}, 'pratica')
    }

    const getFormDataPraticaKey = () => {
      return hasFormDataPratica() ? String(props.formData.pratica) : ''
    }

    const syncPraticaFromFormData = () => {
      if (!hasFormDataPratica()) return

      const pratica = pratiche.value.find(pratica => pratica.value === props.formData.pratica)
      if (pratica) setNewContract(pratica)
    }

    const syncStepInfoFromFormData = () => {
      syncPraticaFromFormData()

      if (!props.formData?.cliente) return

      if (props.formData.typeClient) {
        selectedTypeClient.value = props.formData.typeClient
        const selectedType = typesClient.find(type => type.id == selectedTypeClient.value)
        typesClient.forEach(type => { type.selected = type.id == selectedTypeClient.value })
        canViewSelectionClient.value = selectedType?.view_selection_client
      }

      if (props.formData.agente) selectedAgent.value = props.formData.agente
      if (props.formData.offerte) offerte.value = props.formData.offerte
      if (Array.isArray(props.formData.clientProposedContacts)) {
        contatti.value = props.formData.clientProposedContacts.map(contact => ({
          ...withCompleteContactFields(contact),
          selected: false
        }))
      }

      cliente.value = {
        ...cliente.value,
        ...props.formData.cliente,
        can_view: true
      }
      cf.value = cliente.value.codfis
      piva.value = cliente.value.piva
      if ([1,4,5,6].includes(selectedTypeClient.value)) {
        sameCfPiva.value = selectedTypeClient.value != 4 && cliente.value.codfis == cliente.value.piva
      }

      if (cliente.value.provincia) {
        cities_cliente.value = opzioni.getCities(cliente.value.provincia)
      }
      if (cliente.value.cod_comune) {
        cliente.value.nome_comune = props.formData.cliente.nome_comune || opzioni.getNameCityById(cliente.value.cod_comune)
      }

      if (selectedTypeClient.value != 2 || !props.formData.contatto) return

      const normalizedContatto = getNormalizedContatto(props.formData.contatto)
      const sameAddressContact = getSameAddressContact()

      if (getContattoSyncKey(normalizedContatto) === getContattoSyncKey(sameAddressContact)) {
        sameAddress.value = true
        removeSameAddressContact()
        contatti.value.unshift(sameAddressContact)
        setSelectedContact(sameAddressContact)
        return
      }

      sameAddress.value = false

      if (normalizedContatto.id && !normalizedContatto.updated) {
        const indexContatto = contatti.value.findIndex(contact => contact.id == normalizedContatto.id)

        if (indexContatto >= 0) {
          contatti.value[indexContatto] = {
            ...contatti.value[indexContatto],
            ...normalizedContatto,
            same_to_client: false,
            selected: true
          }
          setSelectedContact(contatti.value[indexContatto])
          return
        }
      }

      selectedContact.value = null
      newContatto.value = true
      contatto.value = normalizedContatto
      const repair = props.formData.clientContactRepair
      if (repair?.sourceId && normalizedContatto.prev_id == repair.sourceId) {
        repairSourceContactId.value = repair.sourceId
        repairLockedFields.value = {...repair.lockedFields}
        repairInitialValues.value = {...repair.initialValues}
      } else {
        resetContactRepair()
      }
      if (normalizedContatto.provincia) {
        cities_contatto.value = opzioni.getCities(normalizedContatto.provincia)
      }
    }

    const removeSameAddressContact = () => {
      contatti.value = contatti.value.filter(contact => !contact.same_to_client)
    }

    const getSameAddressContact = () => {
      const clienteContactPhone = getClienteContactPhone()

      return getNormalizedContatto({
        id: 0,
        same_to_client: true,
        selected: true,
        toponimo: cliente.value.toponimo || '',
        indirizzo: cliente.value.indirizzo || '',
        civico: cliente.value.civico || '',
        cap: cliente.value.cap || '',
        provincia: cliente.value.provincia || '',
        cod_comune: cliente.value.cod_comune || null,
        comune: cliente.value.cod_comune || null,
        nome_comune: cliente.value.nome_comune || '',
        name: cliente.value.nome_comune || '',
        email: cliente.value.email || '',
        cellulare: clienteContactPhone,
        cell: clienteContactPhone
      })
    }

    const setSelectedContact = (contact = null) => {
      if (contact?.invalid_fields?.length > 0) {
        completeContact(contact)
        return
      }
      resetContactRepair()
      if (!contact) {
        selectedContact.value = null
        return
      }

      const normalized = getNormalizedContatto(contact)
      selectedContact.value = normalized
      contatto.value = normalized
      newContatto.value = false
      if (!normalized.same_to_client) removeSameAddressContact()
      contatti.value.forEach(existingContact =>{
        existingContact.selected = existingContact.id == normalized.id
      })
      if (selectedTypeClient.value == 2) sameAddress.value = normalized.same_to_client
      if (normalized.provincia) cities_contatto.value = opzioni.getCities(normalized.provincia)
    }

    const getIndexSelectedContact = (id = null) => {
      if (id) {
        const indexById = contatti.value.findIndex(contact => contact.id == id)
        if (indexById >= 0) return indexById
      }

      const indexSelected = contatti.value.findIndex(contact => contact.selected)
      return indexSelected >= 0 ? indexSelected : (contatti.value.length ? 0 : -1)
    }

    const setContattiFromBackend = (backendContacts = [], option = {}) => {
      contatti.value = backendContacts
        .map(contact => {
          return {...withCompleteContactFields(contact), same_to_client: false, selected: Boolean(contact.selected)}
        })

      const hasBackendContacts = contatti.value.length > 0
      if (!hasBackendContacts) {
        if (selectedTypeClient.value == 2) {
          sameAddress.value = true
          setSameAddress()
        } else {
          newContatto.value = true
          selectedContact.value = null
          sameAddress.value = false
        }
        return
      }

      const restoreNewContact = option.nuovo_contatto === true
        && Number(option.contatto || 0) === 0
        && Number(option.prev_contatto_id || 0) > 0
      if (restoreNewContact) {
        const indexNewContact = contatti.value.findIndex(contact => contact.id == option.prev_contatto_id)
        if (indexNewContact >= 0) {
          const restoredContact = {
            ...getNormalizedContatto(contatti.value[indexNewContact]),
            id: 0,
            prev_id: option.prev_contatto_id,
            selected: false,
            same_to_client: false
          }
          delete restoredContact.updated
          delete restoredContact.complete_fields
          delete restoredContact.invalid_fields
          delete restoredContact.selectable
          contatti.value.splice(indexNewContact, 1)
          contatti.value.forEach(contact => { contact.selected = false })
          resetContactRepair()
          selectedContact.value = null
          sameAddress.value = false
          newContatto.value = true
          contatto.value = restoredContact
          if (restoredContact.provincia) cities_contatto.value = opzioni.getCities(restoredContact.provincia)
          return
        }
      }

      newContatto.value = false
      const idContatto = option.prev_contatto_id || option.contatto || null
      const indexContatto = getIndexSelectedContact(idContatto)
      if (indexContatto < 0) {
        selectedContact.value = null
        newContatto.value = true
        sameAddress.value = false
        return
      }
      setSelectedContact(contatti.value[indexContatto])

      if (option.prev_contatto_id) contatto.value.prev_id = option.prev_contatto_id
      if (contatto.value.cod_comune) contatto.value.nome_comune = opzioni.getNameCityById(contatto.value.cod_comune)
    }

    const addNewContact = () => {
      resetContactRepair()
      removeSameAddressContact()
      selectedContact.value = null
      contatti.value.forEach(contact =>{
        contact.selected = false
      })
      contatto.value = {
        id: 0,
        prev_id: 0,
        toponimo: "",
        indirizzo: "",
        civico: "",
        cap: "",
        provincia: null,
        cod_comune: null,
        comune: null,
        nome_comune: "",
        email: "",
        pec: null,
        tel: null,
        cell: "",
        cellulare: "",
        selected: false,
      }
      sameAddress.value = false
      newContatto.value = true
    }

    const hasValidRouteId = () => {
      return Boolean(route.params.id && route.params.id !== 'null' && route.params.id !== 'undefined')
    }

    const isStepInfoRoute = () => route.path.startsWith('/multisito/step-info')

    const getInitializeKey = () => {
      return [
        route.params.id || 'new',
        route.query.reload || '',
        getFormDataPraticaKey(),
        props.formData?.typeClient || '',
        props.formData?.cliente?.id || props.formData?.cliente?.prev_id || props.formData?.cliente?.codfis || '',
        props.formData?.contatto?.id || props.formData?.contatto?.prev_id || ''
      ].join('::')
    }

    const initializeStepInfo = async () => {
      if (!isStepInfoRoute()) return

      const initializeKey = getInitializeKey()
      if (initializing.value) return
      if (initializedKey.value === initializeKey && !loading.value) {
        syncStepInfoFromFormData()
        return
      }

      initializing.value = true
      emit("activeLoaderCaricamento", true)
      try {
        initClient(true)
        currentUser.value = store.state.auth.user
        let searched_agent = null
        if (currentUser.value.role == 'agent') {
          if (!selectedAgent.value) {
            selectedKeyAgent.value = {0: true}
            selectedAgent.value = currentUser.value.id
          }
          searched_agent = currentUser.value.id

          getOfferteAgent();
        }
        getAgents(searched_agent)
        
        loading.value = true
        setResponsive()
        await getSlides()
        getCodiciAteco()
        getSDI()
        
        pratica_contratto.value = null
        if (hasValidRouteId()) {
          await getDataMatrice()
        }else{
          syncStepInfoFromFormData()
          emit("activeLoaderCaricamento", false)
          loading.value = false
        }
        initializedKey.value = initializeKey
      } finally {
        initializing.value = false
      }
    }

    onMounted(initializeStepInfo)
    onActivated(initializeStepInfo)
    watch(
      () => [route.path, route.params.id, route.query.reload],
      () => initializeStepInfo()
    )

    const getDataMatrice = async () => {
      await service.getDataMatrice(stepIndex, route.params.id)
      .then((res)=>{
        if (!res.res.data.success) {
          toast.add({severity: 'warn', summary: 'Attenzione', detail: res.res.data.message});
          emit('complete')
        }else{
          let data = res.res.data.data
          let pratica = pratiche.value[0]
          if (data.pratica) {
            pratica = pratiche.value.find(pratica => pratica.name.toUpperCase() == data.pratica)
          }
          setNewContract(pratica)

          if (currentUser.value.role == 'admin') {
            selectedAgent.value = data.agente
            onChangeAgent()
          } else {
            const keyFound = findKeyById(agents.value, data.agente) ?? 0;
            selectedKeyAgent.value = {}
            selectedKeyAgent.value[keyFound] = true
            selectedAgent.value = data.agente          
            onChangeAgent({id: data.agente})
          }
          onChangeTypeClient(data.typeClient)
          if (data.typeClient != 3) {
            cf.value = data.cliente.codfis
            if ([1,4,5,6].includes(selectedTypeClient.value)) piva.value = data.cliente.piva

            let option = {
              force: true
            }
            if(data.cliente.nuovo_cliente) option.prev_id = data.cliente.prev_id
            if(data.typeClient == 2) {
              option.contatto = data.cliente.contatto_id
              option.nuovo_contatto = data.cliente.nuovo_contatto === true
              if (option.nuovo_contatto) option.prev_contatto_id = data.cliente.prev_contatto_id
              
            }
            inputCF_PIVA(option)        
          }
        }
      })
      .finally(()=>{
        emit("activeLoaderCaricamento", false)
        loading.value = false
      })
    }

    const findKeyById = (nodes, targetId) => {
      for (const node of nodes) {
        // Se troviamo l'ID, restituiamo la sua key
        if (node.id === targetId) {
          return node.key;
        }
        // Se il nodo ha dei figli, cerchiamo ricorsivamente al loro interno
        if (node.children && node.children.length > 0) {
          const foundKey = findKeyById(node.children, targetId);
          if (foundKey) return foundKey;
        }
      }
      return null;
    };

    const setResponsive = () => {
      window.addEventListener('resize', () => {
        windowSize.value = window.innerWidth
      })
    }

    const getSlides = async () => {
      await service.getSlides(stepIndex)
      .then((res) => {
        slides.value = res.items
        slides.value.forEach(slide => {
          slide.name = `/images/Step/step${stepIndex}-${slide.order}.png`
        })
      })
    }

    const onChangeAgent = (evt = null) => {
      offerte.value = []
      initClient(true)

      if (evt) {
        selectedAgent.value = evt.id
      }
      getOfferteAgent()
    }
    const getAgents = async (id = null) => {
      loaded_agenti.value = false
      if (id) {
        await service.getAgentAgency(id)
        .then((res) => {
          agents.value = res.items
          originalAgents.value = res.items
        })
        .finally(()=>{
          loaded_agenti.value = true
        })
      } else {
        await service.getAgents().then((res) => {
          agents.value = res.items
        })   
        .finally(()=>{
          loaded_agenti.value = true
        })     
      }
    }

    const onInputCodFis = (e) => {
      cliente.value.codfis = e.target.value.toUpperCase()
      cliente.value.piva = sameCfPiva.value ? cliente.value.codfis : cliente.value.piva
    }
    const onSelectedSdi = () => {
      delete validationErrors.value.sdi;
      delete validationErrors.value.sdi_invalid;
    }
    const getSDI = async () => {
      service.getSDI().then((res) => {
        sdi.value = res.items
      })
    }
    const onInputToponimo = (evt, obj) => {
      eval(obj).value.toponimo = evt.target.value.toUpperCase()
      delete validationErrors.value[`toponimo_${obj}`]
    }

    const setSameCfPiva = () => {
      if (sameCfPiva.value) {
        cliente.value.piva = cliente.value.codfis
        delete validationErrors.value.piva
        delete validationErrors.value.piva_exist
        delete validationErrors.value.piva_invalid
      }else{
        delete cliente.value.piva
      }
    }
    const setSameAddress = () => {
      if (sameAddress.value) {
        removeSameAddressContact()
        newContatto.value = false
        contatti.value.forEach(contact =>{
          contact.selected = false
        })
        const sameAddressContact = getSameAddressContact()
        contatti.value.unshift(sameAddressContact)
        setSelectedContact(sameAddressContact)
        return
      }

      removeSameAddressContact()
      selectedContact.value = null
      newContatto.value = false
      contatti.value.forEach(contact =>{
        contact.selected = false
      })
      contatto.value = {
        id: 0,
        prev_id: 0,
        toponimo: "",
        indirizzo: "",
        civico: "",
        cap: "",
        provincia: null,
        cod_comune: null,
        comune: null,
        nome_comune: "",
        email: "",
        pec: null,
        tel: null,
        cell: "",
        cellulare: "",
        selected: false,
      }
    }

    // const getClientsFromType = (type) =>{
    //   clienti.value = clients.value.filter(el => el.cod_type_client == type)
    // }
    const openOfferte = () => {
      visibleOfferte.value = !visibleOfferte.value;
    }

    // const getAllTipoClient = async () => {
    //   // emit("activeLoader", true)
    //   await service.getAllTipoClient().then((res) => {
    //     typesClient.value = res.items
    //     typesClient.value.forEach((el)=>{
    //       el.view_selection_client = el.id != 3
    //       el.selected = false
    //     })
    //   })
    // }
    const getOfferteAgent = () => {
      loaded_offerte.value = false
      service.getOfferteAgent(selectedAgent.value)
      .then((res) => {
        offerte.value = res.items
        delete validationErrors.value.offerte
      })
      .finally(()=>{
        loaded_offerte.value = true
      })
    }
    
    // const getClients = async () => {
    //   await service.getClients().then((res) => {
    //     clients.value = res.items
    //   })
    //   // .finally(()=>{
    //   //   emit("activeLoader", false)
    //   // })
    // }
    // const getToponimi = () => {
    //   service.getToponimi().then((res) => {
    //     toponimi.value = res.items
    //   })
    // }
    // const getDistricts = () => {
    //   service.getDistricts().then((res) => {
    //       province.value = res.items
    //   }) 
    // }
    // const getCities = () => {
    //   service.getCities().then((res) => {
    //       cities.value = res.items
    //   })
    // }

    const onSelectedDistrict = (evt, obj) => {
      eval(`cities_${obj}`).value = opzioni.getCities(evt.value)
      eval(obj).value.cod_comune = null
      if (obj === 'contatto') {
        contatto.value.comune = null
        contatto.value.cap = ''
      }

      delete validationErrors.value[`provincia_${obj}`];
    }
    const onSelectedToponimo = (evt, obj) => {
      delete validationErrors.value[`toponimo_${obj}`];
    }
    const onSelectedAteco = () => {
      delete validationErrors.value.ateco;     
    }

    const onSelectedExistentClient = (id = null) => {
      delete validationErrors.value['existentClient'];
      newContatto.value = false
      selectedContact.value = null

      if (selectedTypeClient.value == 2) {
        getContatti(id)
      }
    }
    const getContatti = (id = null) => {
      service.getContacts(cliente.value.id, 'cliente')
      .then((res) => {
        setContattiFromBackend(res.items, {contatto: id})
      })
    }
    
    const onSelectedCity = (evt, obj) => {
      eval(obj).value.cod_comune = evt.value
      eval(obj).value.nome_comune = opzioni.getNameCityById(evt.value)
      if (obj === 'contatto') {
        contatto.value.comune = evt.value
        contatto.value.cap = getContactCapSettings(evt.value, opzioni.comuni).prefill
      }
      
      delete validationErrors.value[`comune_${obj}`];
    }
    const onSelectedContact = (contact) => {
      setSelectedContact(contact)
      delete validationErrors.value.contact;
    }
    const onSelectedMobile = (evt) => {
      cliente.value.cellulare = evt.target.value;
      showModal.value = true;
      delete validationErrors.value['cellulare_incorrect'];
      delete validationErrors.value['cellulare'];
      delete validationErrors.value['noTelCell'];
    }
    const onSelectedTelefono = (evt) => {
      cliente.value.telefono = evt.target.value;
      delete validationErrors.value['cellulare_incorrect'];
      delete validationErrors.value['cellulare'];
      delete validationErrors.value['noTelCell'];
    }
    const onSelected = (evt) => {
      delete validationErrors.value[evt.target.id];
      if (evt.target.id == 'email') {
        delete validationErrors.value['isEmail'];
      }else if(evt.target.id == 'codfis'){
        delete validationErrors.value['codfis_invalid'];
        delete validationErrors.value['codfis_exist'];
        if (sameCfPiva.value) {
          delete validationErrors.value['piva_invalid'];
          delete validationErrors.value['piva_exist'];
        }
      }else if(evt.target.id == 'piva'){
        delete validationErrors.value['piva_invalid'];
        delete validationErrors.value['piva_exist'];
      }
    }
    const isCorrect = (is_correct = false) => {
      if (!is_correct) {
        validationErrors.value['cellulare_incorrect'] = true;
      }else{
        delete validationErrors.value['cellulare_incorrect'];
      }
      showModal.value = false;
    }


    const setData = (el) => {
      let mese = el.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = el.getFullYear() 
      el = `${anno}-${mese}-01`
      return el
    } 

    const nextPage = async () => {
      submitted.value = true;
      emit("activeLoader", true)
      const navigationStepIndex = selectedTypeClient.value == 2 ? 1 : stepIndex
      const shouldUseSameAddress = selectedTypeClient.value == 2 && sameAddress.value && !selectedContact.value
      if (selectedContact.value && !shouldUseSameAddress) {
        contatto.value = getNormalizedContatto(contatto.value)
      }
      if (shouldUseSameAddress) {
        contatto.value.toponimo = cliente.value.toponimo
        contatto.value.indirizzo = cliente.value.indirizzo
        contatto.value.civico = cliente.value.civico
        contatto.value.cap = cliente.value.cap
        contatto.value.provincia = cliente.value.provincia
        contatto.value.cod_comune = cliente.value.cod_comune
        contatto.value.nome_comune = cliente.value.nome_comune
        contatto.value.email = cliente.value.email
        contatto.value.cellulare = getClienteContactPhone()
        contatto.value.cell = getClienteContactPhone()
      } else {
        contatto.value.cell = repairSourceContactId.value
          ? String(contatto.value.cellulare || '').replace(/\D/g, '')
          : contatto.value.cellulare
      }
      emit('next-page', {
        formData: {
          "typeClient": selectedTypeClient.value,
          "offerte": offerte.value,
          "cliente": cliente.value,
          "rappresentante": null,
          "contatto": contatto.value,
          "clientProposedContacts": contatti.value
            .filter(contact => !contact.same_to_client)
            .map(contact => ({...contact, selected: false})),
          "clientContactRepair": repairSourceContactId.value
            ? {sourceId: repairSourceContactId.value, lockedFields: {...repairLockedFields.value}, initialValues: {...repairInitialValues.value}}
            : null,
          "nome_pratica": nome_pratica_contratto.value,
          "pratica": pratica_contratto.value,
          "agente": selectedAgent.value,
          "sdi": sdi.value
        }
        ,pageIndex: navigationStepIndex
      })
      setTimeout(()=>{
        cliente.value.can_view = true
      }, 2000)
    }

    const canGoToStep2 = computed(() => {
      const res = { disabled: false, message: "" };
      // 1. Controlli macro (sempre validi)
      if (!loaded_agenti.value) return { disabled: true, message: "Attendi il caricamento degli agenti." };
      if (!selectedAgent.value) return { disabled: true, message: "Seleziona un agente." };
      if (!loaded_offerte.value) return { disabled: true, message: "Attendi il caricamento delle offerte." };
      if (offerte.value.length === 0) return { disabled: true, message: "Nessuna offerta disponibile." };
      if (selectedTypeClient.value == 0) return { disabled: true, message: "Seleziona la tipologia di cliente." };
      if (!loaded_cliente.value) return { disabled: true, message: "Attendi la ricerca del cliente." };
      if (cliente.value.exist === null) return { disabled: true, message: "Ricerca un cliente." };
      
      let requiredField = [];
      let shouldCheckEmailFormat = false;
      let emailToValidate = "";
      let sede_cliente = ''
      let sede_contatto = ''
      if (selectedTypeClient.value != 3) {
        const shouldValidateContatto = selectedTypeClient.value == 2 && !sameAddress.value && !selectedContact.value
        const duplicateContact = (shouldValidateContatto || repairSourceContactId.value)
          && findDuplicateContact(contatto.value, contatti.value, currentUser.value?.role === 'admin', selectedTypeClient.value == 2)
        if (duplicateContact) {
          return { disabled: true, message: "Il contatto è già presente tra quelli proposti: seleziona il contatto esistente.", duplicateContact };
        }
        if (shouldValidateContatto && (contatto.value.cod_comune ?? contatto.value.comune) && hasValue(contatto.value.cap)
          && !isContactCapValid(contatto.value.cap, contatto.value.cod_comune ?? contatto.value.comune, opzioni.comuni)) {
          return { disabled: true, message: "Il CAP non è valido per il comune selezionato." };
        }
        requiredField = required_Field.value.cliente
        if (shouldValidateContatto) {
          requiredField = [...required_Field.value.contatto, ...requiredField]  
          sede_contatto = JSON.stringify(contatto.value.toponimo+contatto.value.indirizzo+contatto.value.civico+contatto.value.cap+contatto.value.provincia+contatto.value.cod_comune)
        }
            
        shouldCheckEmailFormat = true;
        emailToValidate = cliente.value.email;
        
        sede_cliente = JSON.stringify(cliente.value.toponimo+cliente.value.indirizzo+cliente.value.civico+cliente.value.cap+cliente.value.provincia+cliente.value.cod_comune)

        // --- VERIFICA FINALE ---
        const missingFields = requiredField.filter(f => !f.val || String(f.val).trim() === "");
        
        if (missingFields.length > 1) {
          return { disabled: true, message: "Inserisci tutti i campi obbligatori per proseguire." };
        } else if (missingFields.length === 1) {
          return { disabled: true, message: `Manca solo un campo: ${missingFields[0].label}` };
        }
  
        const regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (shouldCheckEmailFormat && emailToValidate) {
          if (!regex_email.test(emailToValidate)) return { disabled: true, message: "Formato email non valido." };
          if (shouldValidateContatto && contatto.value.email && !regex_email.test(contatto.value.email)) return { disabled: true, message: "Formato email contatto non valido." };
        }
        if (repairSourceContactId.value && shouldValidateContatto && !isValidMobile(contatto.value.cellulare)) {
          return { disabled: true, message: "Formato cellulare del contatto non valido." };
        }
        
        if (shouldValidateContatto && sede_cliente == sede_contatto) return { disabled: true, message: "Indirizzo cliente e indirizzo di spedizione coincidono." }
      }

      return res;
    });
    
    const prevPage = () => {
      emit('prev-page', {pageIndex: stepIndex});
    }

    const onChangeTypeClient = async (id) => {
      initClient(true)
      selectedTypeClient.value = id      

      let index = typesClient.findIndex(type => type.id == id)
      let tipo = typesClient.find(type => type.id == id)
      typesClient.forEach((el, i)=>{
        el.selected = i == index
      })

      canViewSelectionClient.value = tipo.view_selection_client

      switch (id) {
        case 3:
          cliente.value.exist = false
          if(!(route.params.id && route.params.id !== 'null' && route.params.id !== 'undefined')) nextPage()
        break;
        case 4:
          sameCfPiva.value = false  
          break;
      }
    }
    const mask = computed(() => {
      return {
        cf: [1, 5, 6].includes(selectedTypeClient.value) ? '99999999999' : 'aaaaaa99a99a9**a',
        piva: '99999999999'
      };
    });
    const getCodiciAteco = async () => {
      await service.getCodiciAteco()
      .then((res) => {
        codiciAteco.value = res.items
      })
    }
    const setErrorExistentCfPiva = async (check, property) => {
      await validateExistentCfPiva(check, property)
      .then((res) => {
        res.items ? validationErrors.value[`${property}_exist`] = true : delete validationErrors.value[`${property}_exist`]
      })      
    }
    const validateExistentCfPiva = async (check, property) => {
      emit("activeLoader", true)
      return service.checkExistentClient(cliente.value[property], check, selectedTypeClient.value)
      .finally(() => {
        emit("activeLoader", false)
      })         
    }
    
    const onSelectedView = () => {
      if (activeTabIndex.value == 0) {
        Object.keys(validationErrors.value).forEach((error) => {
          delete validationErrors.value[`${error}`]
        });
      }else{
        delete validationErrors.value.existentClient
        if (selectedTypeClient.value == 2) {
          cliente.value.sdi = '0000000'
        }
      }
    }
    const setNewContract = (pratica) => {
      visibleStepInfo.value = true
      pratica_contratto.value = pratica.value
      nome_pratica_contratto.value = pratica.name
      let index = pratiche.value.findIndex(type => type.id == pratica.id)
      
      pratiche.value.forEach((el, i)=>{
        el.selected = i == index
      })
    }

    const inputCF_PIVA = async (option = {}) => {
      cf.value = cf.value.toUpperCase()
      let required_elements = {
        cf: cf.value
      }
      if ([1,4,5,6].includes(selectedTypeClient.value)) required_elements.piva = piva.value
      
      let can_check_exist_client = Object.values(required_elements).every(el => el !== null && el !== '');

      if (can_check_exist_client) {
        const searchVersion = ++clientSearchVersion
        const searchedTypeClient = selectedTypeClient.value
        loaded_cliente.value = false

        emit("activeLoader", true)
        await service.check_exist_client({type_client: selectedTypeClient.value, datas: required_elements})
        .then((res)=>{
          if (searchVersion !== clientSearchVersion || selectedTypeClient.value !== searchedTypeClient) return
          let data = res.res.data
          initClient()
          cliente.value.exist = data.exist

          if (data.exist) {
            toast.add({severity:'success', detail:'Cliente presente'})
            
            cliente.value = {...data.cliente}
            onSelectedDistrict({value: cliente.value.provincia}, 'cliente')
            cliente.value.cod_comune = data.cliente.cod_comune
            cliente.value.nome_comune = opzioni.getNameCityById(cliente.value.cod_comune)
            if (searchedTypeClient == 2) cliente.value.codiceDestinatario = '0000000'
            
            const missingFieldsCliente = required_Field.value.cliente.filter(f => !f.val || String(f.val).trim() === "");
            
            cliente.value.exist = missingFieldsCliente.length == 0
            cliente.value.missing_items = missingFieldsCliente.map(field => field.item)
            if ('prev_id' in option) cliente.value.prev_id = option.prev_id

            if (selectedTypeClient.value == 2) {
              cliente.value.codiceDestinatario = '0000000'
            }

            if (selectedTypeClient.value == 2) {
              setContattiFromBackend(data.contatti || [], option)

              if (!newContatto.value && !selectedContact.value?.same_to_client) {
                const missingFieldsContatto = required_Field.value.contatto.filter(f => !f.val || String(f.val).trim() === "");
                newContatto.value = missingFieldsContatto.length > 0
              }

              if (newContatto.value) {
                cliente.value.can_view = true
                emit("activeLoader", false)
              }
            }
          } else {
            newContatto.value = selectedTypeClient.value == 2
            if (selectedTypeClient.value == 2) cliente.value.codiceDestinatario = '0000000'
            cliente.value.can_view = true
            cliente.value.codfis = cf.value
            if([1,4,5,6].includes(selectedTypeClient.value)) cliente.value.piva = piva.value
            emit("activeLoader", false)
          }
        })
        .finally(()=>{
          if (searchVersion !== clientSearchVersion || selectedTypeClient.value !== searchedTypeClient) return
          loaded_cliente.value = true
          if ('force' in option && option.force) {
            emit("activeLoader", false)
            cliente.value.can_view = true
          }else{
            if (selectedTypeClient.value != 2 && cliente.value.exist && !canGoToStep2.value.disabled) {
              nextPage()
            }else{
              emit("activeLoader", false)
              cliente.value.can_view = true
            }
          }
        })
      }
    }

    const required_Field = computed(()=>{
      let req = {}
      if (selectedTypeClient.value != 3) {
        req.cliente = [
          { item: 'codfis', val: cliente.value.codfis, label: 'Codice Fiscale' },
          { item: 'codiceDestinatario', val: cliente.value.codiceDestinatario, label: 'Codice SDI' },
          { item: 'toponimo', val: cliente.value.toponimo, label: 'Toponimo' },
          { item: 'indirizzo', val: cliente.value.indirizzo, label: 'Indirizzo' },
          { item: 'civico', val: cliente.value.civico, label: 'Civico' },
          { item: 'cap', val: cliente.value.cap, label: 'CAP' },
          { item: 'provincia', val: cliente.value.provincia, label: 'Provincia' },
          { item: 'cod_comune', val: cliente.value.cod_comune, label: 'Comune' },
          { item: 'cellulare', val: cliente.value.cellulare, label: 'Cellulare' }
        ];

        req.contatto = [
          { item: 'toponimo', val: contatto.value.toponimo, label: 'Toponimo' },
          { item: 'indirizzo', val: contatto.value.indirizzo, label: 'Indirizzo' },
          { item: 'civico', val: contatto.value.civico, label: 'Civico' },
          { item: 'cap', val: contatto.value.cap, label: 'CAP' },
          { item: 'provincia', val: contatto.value.provincia, label: 'Provincia' },
          { item: 'cod_comune', val: contatto.value.cod_comune, label: 'Comune' },
          { item: 'email', val: contatto.value.email, label: 'Email contatto' },
          { item: 'cellulare', val: contatto.value.cellulare ?? contatto.value.cell, label: 'Cellulare contatto' },
        ]

        if (selectedTypeClient.value == 2) {
          req.cliente.push(
            { item: 'nome', val: cliente.value.nome, label: 'Nome' },
            { item: 'cognome', val: cliente.value.cognome, label: 'Cognome' },
            { item: 'email', val: cliente.value.email, label: 'Email' },
          )
        } else {
          req.cliente.push(
            { item: 'ragsoc', val: cliente.value.ragsoc, label: 'Ragione Sociale' },
            { item: 'piva', val: cliente.value.piva, label: 'Partita IVA' },
            { item: 'codiceAteco', val: cliente.value.codiceAteco, label: 'Codice Ateco' }
          )
        }
      }
      return req
    })


    return {
      loading,
      pratiche,
      activeTabIndex,
      toponimi,
      province,
      cities_cliente,
      cities_contatto,
      clients,
      onSelectedDistrict,
      onSelectedToponimo,
      onSelectedAteco,
      onSelectedCity,
      // isIvaAgevolata,
      selectedTypeClient,
      selectedContact,
      repairSourceContactId,
      repairLockedFields,
      isRepairFieldLocked,
      contactCapSettings,
      contactCapSuffix,
      onContactCapSuffixInput,
      repairFormRef,
      needsContactCompletion,
      typesClient,
      offerte,
      submitted,
      canGoToStep2,
      nextPage,
      prevPage,
      validationErrors,
      cliente,
      clientDetailUrl,
      contatto,
      onSelectedMobile,
      onSelectedTelefono,
      showModal,
      isCorrect,
      onSelected,
      slides,
      clienti,
      initClient,
      onSelectedExistentClient,
      sameAddress,
      sameCfPiva,
      setSameCfPiva,
      setSameAddress,
      onInputCodFis,
      onInputToponimo,
      contatti,
      newContatto,
      addNewContact,
      onSelectedContact,
      onSelectedView,
      onSelectedSdi,
      sdi,
      openOfferte,
      visibleOfferte,
      setNewContract,
      visibleStepInfo,
      onChangeTypeClient,
      currentUser,
      agents,
      selectedAgent,
      selectedKeyAgent,
      onChangeAgent,
      windowSize,
      moment,
      search,
      expandedKeys,
      resetFilter,
      codiciAteco,
      canViewSelectionClient,
      nome_pratica_contratto,
      inputCF_PIVA,
      mask,
      cf,
      piva,
      loaded_offerte,
      loaded_agenti,
      loaded_cliente
    }
  },
}
</script>

<style>
  .form-step .p-card-title, .form-step .p-card-subtitle {
      text-align: center;
  }
  #form-cliente .p-tabview-nav{
    flex-wrap: wrap !important;
  }

</style>
<style scoped>
  .box-selected{
    position: relative;
    max-width: 60%;
    margin: 5px auto;
    border-radius: 20px;
    border: 1px solid rgb(105, 105, 105);
  }
  .selected-name {
    margin: 1rem 0 0.75rem;
    padding: 0 2.5rem;
    text-align: center;
  }
  .btn-detail-name {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
  .btn-detail-name:hover,
  .btn-detail-name:focus-visible {
    background-color: rgba(33, 81, 89, 0.1);
    color: #215159;
  }
  .btn-remove-selected {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }
  @media screen and (max-width: 767px) {
    .box-selected {
      max-width: 100%;
    }
  }
  .bg-warning{
    background-color: #ffe034;
  }

  .p-card{
    min-width: 335px !important;
  }
  .scroll-container {
    padding-top: 5px;
    height: 50px;       /* Altezza fissa obbligatoria */
    overflow-y: auto;    /* Mostra lo scroll solo se serve */
  }
  .badge-offerta {
    display: inline-block !important;
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    padding: 5px 7px;
    margin: 3px;
    font-size: 12px;
    border-radius: 3px;
  }
  .btn-tipo-cliente {
    width: 16%;
    height: 75px;
    font-size: large
  }
  .btn-contatto {
    width: 27%;
    min-height: 120px;
    height: 120px;
    font-size: medium;
    overflow: hidden;
    justify-content: center;
  }
  .btn-contatto :deep(.p-button-label) {
    width: 100%;
  }
  .btn-contatto p {
    width: 100%;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
  }
  .btn-contatto.btn-selection.duplicate-contact {
    position: relative;
    overflow: visible;
    z-index: 1;
    animation: duplicate-contact-pulse 1.3s ease-in-out infinite;
  }
  .duplicate-contact-badge {
    position: absolute;
    top: 50%;
    left: -2.6rem;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 50%;
    background: transparent;
    color: #704c00;
    font-size: 1.5rem;
    line-height: 1;
    pointer-events: none;
  }
  @keyframes duplicate-contact-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.06); }
  }
  @media (prefers-reduced-motion: reduce) {
    .btn-contatto.btn-selection.duplicate-contact {
      animation: none;
    }
  }
  .same-client-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin-bottom: 0.35rem;
    padding: 0.22rem 0.55rem;
    border-radius: 4px;
    border: 1px solid rgba(33, 81, 89, 0.25);
    background: #ffffff;
    color: #215159;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1;
  }
  .unselectable-contact-badge {
    display: inline-block;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    background: #fff2f2;
    color: #8b1f1f;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
  }
  .contact-data {
    line-height: 1.35;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .invalid-contact-data {
    width: fit-content;
    max-width: 100%;
    margin: 0;
    padding: 0 0.4rem;
    background: #ffffff;
    color: #a11c1c;
    border-radius: 4px;
    font-weight: 700;
  }
  .contact-field-to-complete :deep(input.p-inputtext:not(:disabled)),
  .contact-field-to-complete :deep(textarea.p-inputtext:not(:disabled)),
  .contact-field-to-complete :deep(.p-dropdown:not(.p-disabled)) {
    background: #fff8e1;
    border: 2px solid #d99500;
    box-shadow: 0 0 0 2px rgba(217, 149, 0, 0.12);
  }
  .completion-note {
    margin-left: 0.3rem;
    color: #946600;
    font-weight: 700;
  }
  .contact-cap-prefix {
    min-width: 4rem;
    justify-content: center;
    background: #e9ecef;
    color: #495057;
    font-weight: 700;
    cursor: not-allowed;
    user-select: none;
  }
  :deep(input.p-inputtext:disabled),
  :deep(textarea.p-inputtext:disabled),
  :deep(.p-dropdown.p-disabled) {
    opacity: 0.6;
    pointer-events: auto;
    cursor: not-allowed;
    background: #f5f5f5;
    color: #6c757d;
  }
  :deep(.p-dropdown.p-disabled .p-dropdown-label),
  :deep(.p-dropdown.p-disabled .p-dropdown-trigger) {
    color: #6c757d;
  }
  :deep(.p-dropdown.p-disabled),
  :deep(.p-dropdown.p-disabled *) {
    cursor: not-allowed !important;
  }
  .contact-repair-form :deep(.p-dropdown .p-inputtext) {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .btn-contatto:disabled {
    overflow-y: auto;
    justify-content: flex-start;
  }
  .btn-pratica{
    width: 24%;
    height: 130px;
    font-size: x-large;
    margin: 5px;
  }
  .btn-selection {
    border-radius: 20px;
    opacity: 0.5;
    /* 1. Aggiungi transform alla transition */
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    /* 2. Imposta la scala ridotta di base */
    transform: scale(0.8); 
  }
  .btn-selection:hover,.btn-reset:hover {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
    opacity: 1;
  }
  .btn-selection.selected {
    opacity: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    /* 4. Riporta alla dimensione piena (o più grande) quando selezionato */
    transform: scale(0.9); 
  }

  @media screen and (max-width: 1400px) {
    .btn-contatto {
      width: 36%;
      min-height: 120px;
      height: 120px;
      font-size: small
    }
    .btn-tipo-cliente {
      width: 40%;
      height: 50px;
      font-size: medium
    }
    .btn-pratica{
      width: 40%;
      height: 60px;
      font-size: large
    }
  }

  @media screen and (max-width: 767px) {
    .btn-contatto {
      width: 100%;
      min-height: 120px;
      height: 120px;
      font-size: 0.95rem;
    }
    .btn-contatto p {
      font-size: 0.95rem;
      line-height: 1.45;
    }
    .same-client-badge {
      font-size: 0.8rem;
    }
    .btn-tipo-cliente {
      width: 100%;
      height: 50px;
      font-size: medium
    }
    .btn-pratica{
      width: 100%;
      height: 60px;
      font-size: large
    }
  }

  .skeleton-custom{
    width: 23%;
    margin: 1%;
    height: 2rem;
    border-radius: 16px
  }
  .btn-contatto.btn-selection {
    text-align: left;
    font-size: 1.15rem;
    font-weight: 400;
    opacity: 1;
  }
  .btn-contatto.btn-selection:not(.selected),
  .btn-contatto.btn-selection:not(.selected):hover {
    background: #8ebac1;
  }
  .btn-contatto.btn-selection.selected {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
  }
  .btn-contatto :deep(.p-button-label) {
    text-align: left;
    font-weight: 400;
  }
  .btn-contatto p {
    font-size: inherit;
  }
  .contact-label {
    font-weight: 700;
    margin-right: 0.2rem;
  }
</style>
